import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../../../environments/environment';
import { CommonService } from '../../common-service';
import { ReturnStruct } from '../../structs/return.struct';
import { ContasPagarConfigRequest } from '../../requests/financas/contas-pagar-config.request';
import { ContasPagarConfigResponse } from '../../responses/financas/contas-pagar-config.response';

@Injectable({
    providedIn: 'root',
})
export class ContasPagarConfigService extends CommonService {
    private apiUrl = `${environment.urlApiFinancas}ContasPagarConfig`;

    constructor(private httpClient: HttpClient) {
        super();
    }

    public get(): Observable<ContasPagarConfigResponse> {
        return this.httpClient
            .get<ContasPagarConfigResponse>(this.apiUrl, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }

    public put(request: ContasPagarConfigRequest): Observable<ReturnStruct> {
        const url = `${this.apiUrl}`;
        return this.httpClient
            .put<ReturnStruct>(url, request, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }
}
